/**
 * Patient-scoped audit helpers.
 *
 * Thin wrappers over `auditService.js` so patient create/update logging keeps
 * its existing call sites while sharing one record shape with every other
 * audited operation.
 */
import { logAuditEvent, AUDIT_SCOPE, serializeAuditValue, computeFieldChanges } from './auditService';

export { serializeAuditValue };

/** @deprecated use `computeFieldChanges` from auditService. */
export const computePatientFieldChanges = computeFieldChanges;

export async function logPatientAuditCreate({ patientId, actorUid, actorEmail, snapshot }) {
  if (!patientId || !actorUid) return;
  await logAuditEvent({
    scope: AUDIT_SCOPE.PATIENT,
    category: 'patient',
    action: 'create',
    entity: 'patient',
    entityId: patientId,
    patientId,
    snapshot,
    actor: { uid: actorUid, email: actorEmail || null },
  });
}

export async function logPatientAuditUpdate({ patientId, actorUid, actorEmail, changes }) {
  if (!patientId || !actorUid || !changes || Object.keys(changes).length === 0) return;
  await logAuditEvent({
    scope: AUDIT_SCOPE.PATIENT,
    category: 'patient',
    action: 'update',
    entity: 'patient',
    entityId: patientId,
    patientId,
    changes,
    actor: { uid: actorUid, email: actorEmail || null },
  });
}
